import React, { lazy } from "react";

import PageContext from "../../contexts/PageContext";
import CatalogContext from "../../contexts/CatalogContext";

import ProductDetail from "./components/item/ProductDetail";
import { useLog } from "../../auth/useLog";

// Contexts

// pages
const CatalogPage = lazy(() => import("./pages/CatalogPage"));
const Asset = lazy(() => import("./pages/Asset"));
const AssetGalleryPage = lazy(() => import("./pages/AssetGalleryPage"));
const ModuleSetPage = lazy(() => import("./pages/ModuleSetPage"));
const HTMLPage = lazy(() => import("./pages/HTMLPage"));
const Parent = lazy(() => import("./pages/Parent"));
const FormPage = lazy(() => import("./pages/FormPage"));
const SaleReportListing = lazy(() => import("./pages/SaleReportListing"));
const DiamondSearch = lazy(() => import("../../components/diamond-search/DiamondSearch"));

export default function PrivateLayoutInner({ uriRoot, ...page }) {
	const LogContext = useLog();
	const [catalog, setCatalog] = React.useContext(CatalogContext);

	const [currentPage, setCurrentPage] = React.useState(page);

	const typeMap = {
		asset: Asset,
		"asset-gallery": AssetGalleryPage,
		"module-set": ModuleSetPage,
		"item-gallery": CatalogPage,
		form: FormPage,
		parent: Parent,
		html: HTMLPage,
		"sale-report-listing": SaleReportListing
	};

	React.useEffect(() => {
		LogContext.log({
			url: window.location.href,
			page,
			action: "visit",
		}, {
			limit: {
				type: "short",
				key: ["page", page.id, "visit"],
			}
		});
	}, [page]);

	const key = uriRoot + '/' + page.slug;
	let createdElement;
	// TODO ... this can be another page type but should be restricted so not just anyone can add a dia search page. so for now, hack...er... technique it this way
	if (page.copy?.toLowerCase().trim().includes("</boss-catalog-diamond-search>")) {
		createdElement = React.createElement(DiamondSearch, { ...page, uriRoot, key });
	}

	createdElement ??= React.createElement(typeMap[page.type?.code || 'html'], { page, uriRoot, key });

	return (
		<PageContext.Provider value={{ currentPage, setCurrentPage }}>
			{createdElement}
			<ProductDetail />
		</PageContext.Provider>
	);
}